import { ROLE_GROUPS } from 'src/app/common/authorization/roles';
import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'dashboard',
    route: '/dashboard',
    allowedRoles: ROLE_GROUPS.TenantAndPharmacy,
  },
  {
    displayName: 'Patients',
    iconName: 'home',
    route: '/patient',
    allowedRoles: ROLE_GROUPS.AllTenant,
  },
  {
    displayName: 'Appointments',
    iconName: 'lock',
    route: '/appointment',
    allowedRoles: ROLE_GROUPS.AllTenant,
  },
  {
    displayName: 'Queue',
    iconName: 'stethoscope',
    route: '/opd/consultation',
    allowedRoles: ROLE_GROUPS.Consultation,
  },
  {
    displayName: 'IPD',
    iconName: 'bed',
    route: '/ipd/management',
    requiresIPD: true,
    allowedRoles: ROLE_GROUPS.AllTenant,
  },
  {
    displayName: 'Pharmacy',
    iconName: 'pill',
    route: '/pharmacy',
    requiresPharmacy: true,
    allowedRoles: ROLE_GROUPS.Pharmacy,
  },
  {
    displayName: 'Reports',
    iconName: 'box-multiple',
    allowedRoles: ROLE_GROUPS.AllTenant,
    children: [
      {
        displayName: 'Patient Report(OPD)',
        iconName: 'point',
        openDialog: true,
      },
      {
        displayName: 'Billing Report',
        iconName: 'point',
        route: '/reports/billing',
      },
      {
        displayName: 'Audit Logs',
        iconName: 'point',
        route: '/reports/audit-log',
        allowedRoles: ROLE_GROUPS.AdminOnly,
      },
    ]
    // children: [
    //   {
    //     displayName: 'Patient ALL',
    //     iconName: 'point',
    //     route: '/menu-1',
    //   }
    // ]
  }
  // {
  //   displayName: 'Report',
  //   iconName: 'box-multiple',
  //   route: '/menu-level',
  //   children: [
  //     {
  //       displayName: 'Patient ALL',
  //       iconName: 'point',
  //       route: '/menu-1',
  //     },
  //     {
  //       displayName: 'Patient IPD',
  //       iconName: 'point',
  //       route: '/menu-2',
  //     },
  //     {
  //       displayName: 'Patient OPD',
  //       iconName: 'point',
  //       route: '/menu-2',
  //     },
  //   ],
  // },
  // {
  //   displayName: 'Disabled',
  //   iconName: 'ban',
  //   route: '/disabled',
  //   disabled: true,
  // },
  // {
  //   displayName: 'Chip',
  //   iconName: 'mood-smile',
  //   route: '/',
  //   chip: true,
  //   chipClass: 'bg-primary text-white',
  //   chipContent: '9',
  // },
  // {
  //   displayName: 'Outlined',
  //   iconName: 'mood-smile',
  //   route: '/',
  //   chip: true,
  //   chipClass: 'b-1 border-primary text-primary',
  //   chipContent: 'outlined',
  // },
  // {
  //   displayName: 'External Link',
  //   iconName: 'star',
  //   route: 'https://www.google.com/',
  //   external: true,
  // },
];
